import gql from 'graphql-tag';

export const CREATE_STAY_INFORMATION_MUTATION = gql`
  mutation CreateStayInformation($data: createStayInformationInput!) {
    createStayInformation(input: $data) {
      stayInformation {
        id
        locale
        bannerImage {
          url
        }
        title
        locale
        content
      }
    }
  }
`;
